import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import StudioGallery from './gallery'
import Container from '../../components/container'
import PageLayout from '../../layout/page_layout'
import Booking from './booking'
import Typography, { TypographyColor } from '../../components/typography'
import Grid from '../../components/grid'
import { StudioService } from '../../apilibrary'
import { IStudioModel, StudioStatus } from '../../apilibrary/types/studio'
import Editor from '../../components/quill_editor'
import StudioHeaderFragment, { OwnerDetailProps } from './header'
import Card from '../../components/card'
import { trackStudioView } from '../../utils/analytics';

const StudioDelistedPanel: React.FC = () => {
  return (
    <Card sx={{
      p: 4
    }}>
      <Typography variant="h3" color={TypographyColor.WARNING} align="center">This studio currently not accepting booking</Typography>
    </Card>
  )
}

const StudioViewPage: React.FC = () => {
  const [studio, setStudios] = React.useState<IStudioModel>()
  const [studioPictureUrls, setStudioPictureUrls] = React.useState<string[]>([])
  const [ownerProfile, setOwnerProfile] = React.useState<OwnerDetailProps>()
  const { studioId } = useParams() as { studioId: string }

  useEffect(() => {
    const fetchStudio = async (): Promise<void> => {
      const response = await StudioService.getStudioById(studioId)
      await trackStudioView(response)
      setStudios(response)
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const ownerProfile = await response.getOwnerProfile()
      setOwnerProfile({
        ownerId: response.ownerId,
        firstName: ownerProfile?.firstName,
        lastName: ownerProfile?.lastName
      })
      const urls = await Promise.all(response.info.studioPictures.map(async (picture) => {
        const url = await picture.getPublicUrl()
        return url
      }))
      setStudioPictureUrls(urls)
    }
    void fetchStudio()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!studio || !ownerProfile) {
    return <Typography>Loading...</Typography>
  }

  return (
    <PageLayout>
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StudioHeaderFragment
              studioId={studio.id}
              title={studio.info.title}
              ownerProfile={ownerProfile}
              minSessionLength={studio.info.minSessionMinutes}
              city={studio.info.location.city}
              state={studio.info.location.state}
              maxOccupancy={studio.info.maxOccupancy}
            />
          </Grid>
          <Grid item xs={12}>
            <StudioGallery studioPictureUrls={studioPictureUrls} />
          </Grid>
          <Grid item xs={12} md={9}>
            <Editor readOnly value={studio.info.description} />
          </Grid>
          <Grid item xs={12} md={3}>
            {studio.status !== StudioStatus.ACTIVE
              ? <StudioDelistedPanel />
              : <Booking studioId={studio.id} hourlyRate={studio.info.rate} minSessionLength={studio.info.minSessionMinutes} />
}
          </Grid>
        </Grid>
      </Container>
    </PageLayout>
  )
}

export default StudioViewPage
